import BaseComponent from "../../baseComponent.js";

export default class LineChart extends BaseComponent {
  componentDidMount() {
    var t = new Date().getTime();
    var height = $(window).height() - 42 - 50 - 32 - 400 - 60;
    $("#awh-chart-container").height(height);
    var lineChartData = [{
      label: "DataSeries0",
      values: [
        {time: t, y: 1.24673},
        {time: t, y: 1.246731},
        {time: t, y: 1.246732},
        {time: t, y: 1.246733},
        {time: t, y: 1.246734},
        {time: t, y: 1.246735},
        {time: t, y: 1.246736},
        {time: t, y: 1.246737},
        {time: t, y: 1.246738},
        {time: t, y: 1.246739},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.24674},
        {time: t, y: 1.246739},
        {time: t, y: 1.246738},
        {time: t, y: 1.246737},
        {time: t, y: 1.246736},
        {time: t, y: 1.246735},
        {time: t, y: 1.246736},
        {time: t, y: 1.246737},
        {time: t, y: 1.246738},
        {time: t, y: 1.246739},
        {time: t, y: 1.246740},
        {time: t, y: 1.246741},
        {time: t, y: 1.246742},
        {time: t, y: 1.246743},
        {time: t, y: 1.246744},
        {time: t, y: 1.246745},
        {time: t, y: 1.246746},
        {time: t, y: 1.246747},
        {time: t, y: 1.246746},
        {time: t, y: 1.246745},
        {time: t, y: 1.246744},
        {time: t, y: 1.2467438},
        {time: t, y: 1.2467436},
        {time: t, y: 1.2467434},
        {time: t, y: 1.2467432},
        {time: t, y: 1.2467430},
        {time: t, y: 1.2467428}

      ]
    }];

    $('#awh-chart').epoch({
      type: "time.series",
      data: lineChartData,
      axes: ['bottom', 'left'],
      margins: {left: 70},
      tickFormats: {
        left: function (d) {
          var multiplier = Math.pow(10, 10);
          return (Math.round(d * multiplier) / multiplier);
        }
      },
      getSnapshotData: function () {
      },
      onChartSlide: function () {
      },
      onChartZoom: function () {
      },
      getWidgetLegends: function () {
        return [
          {
            "parameters": {
              "legendLabel": "USD/CAD SPOT",
              "yAxisSide": "left",
              "chartType": "line",
              "legendColor": "#ff7f0e",
              "chartTypeParameters": {
                fillOpacity: 1,
                strokeOpacity: 1
              }
            }
          }
        ]
      },
      isDemoChart: true,
      queueSize: 1,
      historySize: 40
    });

    var spots = [
      {id: "loblaw", top: 10.7, left: 16.7, color: "#75a641"},
      {id: "loblaw", top: 10.7, left: 61.7, color: "#75a641"},
      {id: "fx-sales", top: 27.8, left: 18, color: "#ff9900"},
      {id: "fx-sales", top: 27.8, left: 61, color: "#ff9900"},
      {id: "fx-risk", top: 33, left: 20, color: "#f06292"},
      {id: "fx-risk", top: 37, left: 58, color: "#f06292"},
      {id: "barx-3m", top: 36.8, left: 23.6, color: "#8e7cc3"},
      {id: "barx-3m", top: 36.8, left: 26.6, color: "#8e7cc3"},
      {id: "barx-1-5m", top: 39.8, left: 35.6, color: "#8e7cc3"},
      {id: "barx-1-5m", top: 39.8, left: 37.6, color: "#8e7cc3", rejected: true},
      {id: "barx-1m", top: 51.8, left: 51.6, color: "#8e7cc3"},
      {id: "barx-1m", top: 50.8, left: 53.6, color: "#8e7cc3"},
      {id: "boa", top: 34, left: 31, color: "#3ba4ed"},
      {id: "boa", top: 39.3, left: 39.5, color: "#3ba4ed"},
      {id: "hsfx", top: 45.3, left: 42.5, color: "#b0c347"},
      {id: "hsfx", top: 55.3, left: 44.5, color: "#b0c347"}
    ];


    var prevDot = null;
    for (var i = 0; i < spots.length; i++) {
      var dot = $("<div class='order-spot' data-id='" + spots[i].id + "'></div>");
      var line = null;
      if ((i + 1) % 2 === 0) {
        dot.css({
          top: spots[i].top + "%",
          left: spots[i].left + "%",
          backgroundColor: spots[i].color
        });
      } else {
        dot.css({
          top: spots[i].top + "%",
          left: spots[i].left + "%",
          border: "2px solid " + spots[i].color
        });
      }

      var ghost = $("<div class='spot-pulse-ring'></div>").css({
        top: spots[i].top + "%",
        left: spots[i].left + "%"
      });
      if (i !== 0) {
        dot.hide();
      } else {
        //ghost.addClass("pulse-active");
      }
      $('#awh-chart').append(dot).append(ghost);

      var offset = ghost.offset();
      ghost.offset({top: offset.top - 5, left: offset.left - 5});
      prevDot = dot;
    }

    $($(".spot-pulse-ring")[0]).addClass("pulse-active");

    var activeElement = null;


    $("#loblaw").on("click", function () {

      $(".ah-circle").hover(function () {
        if (activeElement !== null) return;
        var dataId = $(this).attr("data-id");
        $(".order-spot[data-id='" + dataId + "']").next("div").addClass("pulse-active");
        $(".order-spot[data-id!='" + dataId + "']").addClass("spot-blur");
      }, function () {
        if (activeElement !== null) return;
        var dataId = $(this).attr("data-id");
        $(".order-spot[data-id='" + dataId + "']").next("div").removeClass("pulse-active");
        $(".order-spot[data-id!='" + dataId + "']").removeClass("spot-blur");
      });

      var allSpots = $(".order-spot");
      var index = 0;

      setTimeout(function () {
        show();
      }, 400);

      function show() {
        if (index > allSpots.length - 1) return;
        $(allSpots[index]).show(160, function () {
          index++;
          show();
        });
      }
    });

    $("#fx-risk-clone").on("click", function () {
      $(".order-spot").next("div").removeClass("pulse-active").removeClass("pulse-active-force");
      $(".order-spot").removeClass("spot-blur").removeClass("spot-blur-force");
      activeElement = null;
    });


    $("#fill-ratio-wrapper")
      .find("div")
      .on("click", function () {
        var id = $(this).attr("data-id");

        if (id == "barx") {
          $(".order-spot[data-id='barx-1m']").next("div").css("background-color", "red");
        }

        if (activeElement !== null) activeElement.removeAttr("active");
        $(".order-spot").next("div").removeClass("pulse-active").removeClass("pulse-active-force");
        $(".order-spot").removeClass("spot-blur").removeClass("spot-blur-force");
        $(".order-spot[data-id*='" + id + "']").next("div").addClass("pulse-active-force");
        $(".order-spot").not("[data-id*='" + id + "']").addClass("spot-blur-force");
        $(this).attr("active", true);
        activeElement = $(this);
      })
      .hover(function () {
        if (activeElement !== null) return;
        var id = $(this).attr("data-id");
        $(".order-spot[data-id*='" + id + "']").next("div").addClass("pulse-active");
        $(".order-spot").not("[data-id*='" + id + "']").addClass("spot-blur");
      }, function () {
        if (activeElement !== null) return;
        var id = $(this).attr("data-id");
        $(".order-spot[data-id*='" + id + "']").next("div").removeClass("pulse-active");
        $(".order-spot").not("[data-id*='" + id + "']").removeClass("spot-blur");
      });

    $("#barx-ratio-wrapper")
      .find("div")
      .hover(function () {
        var id = $(this).attr("data-id");
        if (id.indexOf("barx") > -1) {
          $(".order-spot[data-id*='barx']").next("div").removeClass("pulse-active-force");
          $(".order-spot[data-id*='barx']").addClass("spot-blur-force");
          $(".order-spot[data-id='" + id + "']").next("div").addClass("pulse-active-force");
          $(".order-spot[data-id='" + id + "']").removeClass("spot-blur-force");
        }
      }, function () {
        var id = $(this).attr("data-id");
        if (id.indexOf("barx") > -1) {
          $(".order-spot[data-id*='barx']").next("div").addClass("pulse-active-force");
          $(".order-spot[data-id*='barx']").removeClass("spot-blur-force");
        }
      });
    // hardcode time stamps and include milliseconds
    var counter = 8;
    $('.tick.major').each(function () {
      var ms = counter * 100;
      counter--;
      $(this).find('text').text('09:24:21.' + ms + 'AM');
    });
  }

  render() {
    var style = {
      position: "relative"
    };
    var style2 = {
      height: "300px",
      position: "absolute",
      width: "80%",
      marginLeft: "-40%",
      left: "50%",
      minWidth: "800px"
    };
    return (
      <div id="awh-chart-container" style={style}>
        <div id="awh-chart" className="epoch category10" style={style2}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/auto-hedging-widget/lineChart.jsx